/* Barra de envío gratis: anima el progreso entre renders del carrito (el drawer se re-renderiza completo en cada cambio). */
if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      const fill = this.querySelector('.fsb__fill');
      if (!fill) return;

      const ctx = this.dataset.context || 'drawer';
      const state = this.dataset.state || 'locked';
      const target = Math.min(1, Math.max(0, parseFloat(this.dataset.progress) || 0));

      window.__fsb = window.__fsb || { progress: {}, state: {} };
      const prevProgress = typeof window.__fsb.progress[ctx] === 'number' ? window.__fsb.progress[ctx] : 0;
      const prevState = window.__fsb.state[ctx];
      window.__fsb.progress[ctx] = target;
      window.__fsb.state[ctx] = state;

      // Cambio de estado (bloqueado -> desbloqueado): anima el texto
      if (prevState && prevState !== state) this.classList.add('fsb--flip');

      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || prevProgress === target) {
        fill.style.transform = 'scaleX(' + target + ')';
        return;
      }

      // Arranca desde el progreso anterior y anima hasta el nuevo
      fill.style.transition = 'none';
      fill.style.transform = 'scaleX(' + prevProgress + ')';

      // Si el drawer aun se esta abriendo, espera a que termine de deslizar
      const drawer = this.closest('cart-drawer');
      const delay = drawer && !drawer.classList.contains('active') ? 320 : 0;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fill.style.transition = '';
          fill.style.transitionDelay = delay + 'ms';
          fill.style.transform = 'scaleX(' + target + ')';
        });
      });
    }
  }
  customElements.define('free-shipping-bar', FreeShippingBar);
}